// src/components/shared/profile-actions/FriendsDrawer.tsx

"use client";

import React from "react";
import { useRouter } from "next/navigation";

import { AvatarDisplay, BottomDrawer } from "../../common";

import "./FriendsDrawer.css";

type Friend = {
  id: number;
  username: string;
  name?: string | null;
  family?: string | null;
  avatar_url?: string | null;
  label?: {
    color?: string | null;
  } | null;
  is_verified_identity?: boolean;
  is_townlit_verified?: boolean;
  profile_url?: string | null;
};

interface Props {
  open: boolean;
  onClose: () => void;
  friends: Friend[];
}

/**
 * Drawer that displays profile friends
 */
const FriendsDrawer: React.FC<Props> = ({
  open,
  onClose,
  friends,
}) => {
  const router = useRouter();
  const friendCount = friends.length;

  const title =
    friendCount === 1
      ? "1 Friend"
      : `${friendCount} Friends`;

  return (
    <BottomDrawer
      open={open}
      onClose={onClose}
      title={title}
      maxHeight="75vh"
    >
      <div className="friends-drawer">
        {friends.length === 0 && (
          <div className="friends-empty">
            No friends to display
          </div>
        )}

        {friends.map((f) => {
          const fullName = `${f.name ?? ""} ${f.family ?? ""}`.trim();

          const goToProfile = () => {
            if (f.profile_url) {
              router.push(f.profile_url);
            }
          };

          return (
            <div key={f.id} className="friends-item">
              <AvatarDisplay
                userId={f.id}
                src={f.avatar_url || ""}
                alt={fullName || f.username}
                size="md"
                shape="rounded"
                withBorder
                borderColor={f?.label?.color || undefined}
                type="user"
                isVerifiedIdentity={Boolean(f?.is_verified_identity)}
                isTownlitVerified={Boolean(f?.is_townlit_verified)}
                onClick={goToProfile}
              />

              <div
                className="friends-text"
                onClick={goToProfile}
              >
                {fullName ? (
                  <div className="friends-name">
                    {fullName}
                  </div>
                ) : null}

                <div className="friends-username">
                  @{f.username}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </BottomDrawer>
  );
};

export default FriendsDrawer;